<template>
  <div id="Conceptualizacion">
      <header class="cont-tit">
          <h2 class="tit">Conceptualización</h2>
          <div class="description-card">
              <div class="card-icon">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M9 12L11 14L15 10" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
              </div>
              <div class="card-content">
                  <p class="bajada">
                      En este botón puedes encontrar ayuda para la fase de generar ideas. <br> Si quieres observar el índice y la extensión de las tesis de un año en particular, indícalo. Si deseas buscar por patrón, te sugerimos marcar la opción 'todos los años'.
                  </p>
              </div>
          </div>
      </header>
      <div class="wrapper">
          <FormulateForm class="filterbar" @submit="submitHandler" #default="{ isLoading }">
              <div class="form-group">
                  <div class="form-group">
                      <FormulateInput
                              type="text"
                              name="patron"
                              label="Patrón"
                              label-class="control-label"
                              placeholder="Patrón"
                              v-model="patron"
                      />
                  </div>
              </div>
              <div class="form-group">
                  <div class="form-group">
                      <FormulateInput
                              type="select"
                              name="anio"
                              label="Año"
                              label-class="control-label"
                              placeholder="Seleccione"
                              :options="optionsTipoAnio"
                              v-model="anio"
                      />
                  </div>
              </div>
              <div class="form-group">
                  <div class="form-group">
                      <FormulateInput
                              type="select"
                              name="funcs"
                              label="Función"
                              label-class="control-label"
                              placeholder="Seleccione"
                              :options="optionsFunciones"
                              v-model="funciones"
                      />
                  </div>
              </div>
              <FormulateInput
                      type="submit"
                      :disabled="isLoading"
                      :label="isLoading ? 'Cargando...' : 'BUSCAR'"
                      class="formulate-input"
                      v-b-modal.modal-xl
              />

          </FormulateForm>

          <!-- <div class="accordion" role="tablist" id="accordion1">
            <span v-html="resIndice"></span>
          </div> -->
          <b-modal id="modal-xl" size="xl" :title="funciones" hide-footer>
              <div class="accordion" role="tablist" id="accordion2">
                  <b-card v-for="(item, index) in resIndice2" v-bind:key="index" no-body class="mb-1">
                      <b-card-header header-tag="header" class="p-1" role="tab">
                          <b-button block v-b-toggle="`collapse-${ index }`" variant="info">{{ item.title }}</b-button>
                      </b-card-header>
                      <b-collapse :id="`collapse-${ index }`" accordion="my-accordion" role="tabpanel">
                          <b-card-body>
                              <b-card-text v-html="item.paper_index"></b-card-text>
                          </b-card-body>
                      </b-collapse>
                  </b-card>
              </div>
          </b-modal>
      </div>
      <!-- tabs -->
      <!--<div class="content">-->
       <!-- <nav class="tabs__bar tab-btns">
          <a
            href="#"
            class="tab"
            data-toggle-target=".tab-content-1"
            :class="{ 'active': isSelected(0) }"
            @click="selected = 0"
          >
            Indice
          </a>
          <a
            href="#"
            class="tab"
            data-toggle-target=".tab-content-2"
            :class="{ 'active': isSelected(1) }"
            @click="selected = 1"
          >
            Extension
          </a>
        </nav>
        <div class="tabs__content tab-content tab-content-1"
          :class="{ 'active': isSelected(0) }">
          <TabIndice />
        </div>
        <div
          class="tabs__content tab-content tab-content-2"
          :class="{ 'active': isSelected(1) }"
        >
          <TabExtension />
        </div>

      </div>
      -->
      <!-- / tabs -->
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "TabConceptualizacion",
    data() {
        return {
            resIndice: null,
            resIndice2: [{'title':'','paper_index':''}],
            patron: null,
            anio: "null",
            funciones: null,
            optionsFunciones:[
                {value: 'Indice', label:"Indice"},
                {value: 'Extension', label:"Extension"}
            ],
            optionsTipoAnio: [
                { value: "null", label: "Todos los años" },
                { value: "2007", label: "2007" },
                { value: "2008", label: "2008" },
                { value: "2009", label: "2009" },
                { value: "2010", label: "2010" },
                { value: "2011", label: "2011" },
                { value: "2012", label: "2012" },
                { value: "2013", label: "2013" },
                { value: "2014", label: "2014" },
                { value: "2015", label: "2015" },
                { value: "2016", label: "2016" },
                { value: "2017", label: "2017" },
                { value: "2018", label: "2018" },
                { value: "2019", label: "2019" },
                { value: "2020", label: "2020" },
                { value: "2021", label: "2021" },

            ],
        };
    },
    methods: {
        async submitHandler() {
            let loader = this.$loading.show({ isFullPage: true, canCancel: false });
            try {
                const formData = new FormData();
                formData.append("patron", this.patron);
                formData.append("anio", this.anio);
                formData.append("funciones", this.funciones);
                let res = await axios.post(
                    `${process.env.VUE_APP_API_URL}/api/Conceptualizacion`,
                    formData
                );
                this.resIndice = res.data.html_response;
                this.resIndice2 = res.data.context2;
                this.makeToast(
                    "Mostrar Indice realizado exitosamente.",
                    "success"
                );
            } catch (err) {
                console.warn(err);
                this.makeToast(err, "danger");
            }
            loader.hide();
        },
        makeToast(message, variant) {
            let title =
                variant == "success" ? "Operación exitosa" : "Operación fallida";
            this.$bvToast.toast(message, {
                title: title,
                variant: variant,
                solid: false,
                autoHideDelay: 2000,
            });
        },
    },
};
</script>

<style scoped>
/* Description Card Styles */
.description-card {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  padding: 1rem;
  background: var(--background-color);
  border: 1px solid var(--border-color);
  border-radius: var(--radius-md);
  margin-top: 1rem;
  box-shadow: var(--shadow-sm);
  transition: all 0.2s ease;
}

.description-card:hover {
  box-shadow: var(--shadow-md);
  border-color: var(--primary-color);
}

.card-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  background: var(--primary-color);
  color: white;
  border-radius: var(--radius-sm);
  flex-shrink: 0;
}

.card-content {
  flex: 1;
  min-width: 0;
}

.bajada {
  margin: 0;
  font-size: 0.875rem;
  line-height: 1.5;
  color: var(--text-secondary);
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .description-card {
    padding: 0.875rem;
    gap: 0.625rem;
  }
  
  .card-icon {
    width: 28px;
    height: 28px;
  }
  
  .bajada {
    font-size: 0.8125rem;
  }
}

@media (max-width: 480px) {
  .description-card {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
  }
  
  .card-icon {
    align-self: flex-start;
  }
}
</style>